var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_23895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 18.3341H12.9993C17.166 18.3341 18.8327 16.6675 18.8327 12.5008V7.50081C18.8327 3.33415 17.166 1.66748 12.9993 1.66748H7.99935C3.83268 1.66748 2.16602 3.33415 2.16602 7.50081V12.5008C2.16602 16.6675 3.83268 18.3341 7.99935 18.3341Z",
    stroke: "#526C7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6084 12.075L8.59173 9.49999C8.87507 9.13332 9.40007 9.06665 9.76673 9.34999L11.2917 10.55C11.6584 10.8333 12.1834 10.7667 12.4667 10.4083L14.3917 7.92499",
    stroke: "#526C7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_23895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeLight);
export default __webpack_public_path__ + "static/media/tradeLight.68a8f3687c19fe6a3959f82e6d80a552.svg";
export { ForwardRef as ReactComponent };